import { useEffect, useState } from 'react';
import { getMiningProductionDashboardData } from '../../api/getMiningProductionDashboardData';
import { MiningProducedDashboard } from '../../models/types/MiningProducedDashboard';
import { currencyFormatter } from '../../utils/currencyFormatter';

export default function MiningProducedDashboardPage() {
  const [data, setData] = useState<MiningProducedDashboard>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getMiningProductionDashboardData()
      .then((res) => setData(res))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="m-5 p-5 bg-gray-100 rounded-lg shadow-lg">
      <h2 className="text-xl font-semibold text-gray-800 mb-4">
        Eddig bányászott Bitcoin csoportonként
      </h2>

      {loading ? (
        <p className="text-center text-lg animate-pulse">Betöltés...</p>
      ) : (
        data && (
          <>
            <div className="overflow-x-auto">
              <table className="min-w-full border-separate border-spacing-y-1">
                <thead className="bg-gray-200 sticky top-0">
                  <tr>
                    <th className="px-4 py-2 text-left text-sm font-medium text-gray-600">Csoportnév</th>
                    <th className="px-4 py-2 text-right text-sm font-medium text-gray-600">Teljes mennyiség (db)</th>
                    <th className="px-4 py-2 text-right text-sm font-medium text-gray-600 text-dark-brown">Ebből ügyfél részesedése (db)</th>
                    <th className="px-4 py-2 text-right text-sm font-medium text-gray-600 text-dark-brown">Ebből a cég részesedése (db)</th>
                    <th className="px-4 py-2 text-right text-sm font-medium text-gray-600 text-dark-brown">Az ügyfelek által birtokolt BTC mai ára</th>
                    <th className="px-4 py-2 text-right text-sm font-medium text-gray-600 text-dark-brown">A cég által birtokolt BTC mai ára</th>
                  </tr>
                </thead>
                <tbody>
                  {data.groups.map((group, idx) => (
                    <tr
                      key={idx}
                      className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}
                    >
                      <td className="px-4 py-2 text-sm text-gray-800">{group.group_name}</td>
                      <td className="px-4 py-2 text-sm text-right text-gray-800">
                        {group.total_amount.toLocaleString()}
                      </td>
                      <td className="px-4 py-2 text-sm text-right text-dark-brown font-semibold">
                        {group.client_share.toLocaleString()}
                      </td>
                      <td className="px-4 py-2 text-sm text-right text-dark-brownfont-semibold">
                        {group.company_share.toLocaleString()}
                      </td>
                      <td className="px-4 py-2 text-sm text-right text-dark-brownfont-semibold">{currencyFormatter(group.client_share_price, 'USD')}</td>
                      <td className="px-4 py-2 text-sm text-right text-dark-brownfont-semibold">{currencyFormatter(group.company_share_price, 'USD')}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="mt-6 text-right space-y-1 text-gray-800 text-sm">
              <p>Ügyfél összes mennyiség: <span className="font-semibold text-dark-brown">{data.totalClientCoins.toLocaleString()}</span></p>
              <p>Cég összes mennyiség: <span className="font-semibold text-dark-brown">{data.totalCompanyCoins.toLocaleString()}</span></p>
              <p>Ügyfél érték: <span className="font-semibold text-dark-brown">{currencyFormatter(parseFloat(data.totalClientCoinsPrice), 'USD')}</span></p>
              <p>Cég érték: <span className="font-semibold text-dark-brown">{currencyFormatter(parseFloat(data.totalCompanyCoinsPrice), 'USD')}</span></p>
              <p>Teljes érték: <span className="font-bold text-gray-900">{currencyFormatter(parseFloat(data.totalPrice), 'USD')}</span></p>
            </div>
          </>
        )
      )}
    </div>
  );
}
